interface CreateRoomImageFieldProps {
  imagePreview: string | null;
  isLoading: boolean;
  onRemoveImage: () => void;
  onOpenPicker: () => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputRef: React.RefObject<HTMLInputElement>;
}

/**
 * Image picker field for room creation.
 */
export function CreateRoomImageField({
  imagePreview,
  isLoading,
  onRemoveImage,
  onOpenPicker,
  onChange,
  inputRef,
}: CreateRoomImageFieldProps) {
  return (
    <div className="mb-5">
      <label className="block text-sm font-medium text-gray-300 mb-2">Room Image (optional)</label>

      {imagePreview ? (
        <div className="relative aspect-[16/10] rounded-lg overflow-hidden bg-black">
          <img
            src={imagePreview}
            alt="Preview"
            className="w-full h-full object-cover"
          />
          <button
            type="button"
            onClick={onRemoveImage}
            className="absolute top-2 right-2 p-2 bg-black/70 hover:bg-black/90 rounded-lg transition-colors"
            disabled={isLoading}
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={onOpenPicker}
          className="w-full aspect-[16/10] rounded-lg border-2 border-dashed border-gray-600 hover:border-gray-500 bg-[#0f0f0f] flex flex-col items-center justify-center gap-2 text-gray-500 hover:text-gray-400 transition-colors"
          disabled={isLoading}
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <span className="text-sm">Click to upload image</span>
        </button>
      )}

      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/gif,image/webp"
        onChange={onChange}
        className="hidden"
      />
      <p className="mt-2 text-xs text-gray-500">
        JPEG, PNG, GIF, or WebP. Max 5MB.
      </p>
    </div>
  );
}
